import { type ReactNode, useEffect, useMemo } from "react";
import { useStateMachine } from "@/core/arch/state_machine";
import { AdminUserBloc } from "@/application/admin_user/admin_user_bloc";
import { ProvisioningRepository } from "@/application/provisioning/provisioning_repository";
import { ProvisioningListBloc } from "@/application/provisioning/provisioning_list_bloc";
import { ProvisioningBloc } from "@/application/provisioning/provisioning_bloc";
import { DashboardBloc } from "@/application/provisioning/dashboard_bloc";
import { AdminAppContext } from "@/core/admin_app_context";
import { initStripePlatformAccounts } from "@/lib/stripe-platform-accounts";

export function AdminAppProvider({ children }: { children: ReactNode }) {
  // Fetch platform account IDs once on app startup — cached for the session.
  useEffect(() => {
    void initStripePlatformAccounts();
  }, []);
  const [, adminUserBloc] = useStateMachine(() => new AdminUserBloc());
  const repo = useMemo(() => new ProvisioningRepository(), []);
  const [, provisioningListBloc] = useStateMachine(
    () => new ProvisioningListBloc(repo),
  );
  const [, provisioningBloc] = useStateMachine(
    () => new ProvisioningBloc(repo),
  );
  const [, dashboardBloc] = useStateMachine(() => new DashboardBloc(repo));

  return (
    <AdminAppContext.Provider
      value={{
        adminUserBloc,
        provisioningRepo: repo,
        provisioningListBloc,
        provisioningBloc,
        dashboardBloc,
      }}
    >
      {children}
    </AdminAppContext.Provider>
  );
}
